import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  NotificationTemplatesPage,
  notificationTemplatesQueryOptions,
} from '@/features/notifications';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/notifications')({
  staticData: { crumb: 'common:nav.notifications', tours: ['settings.notifications'] },
  // Marketing holds notifications.write without settings.read; the backend accepts either.
  beforeLoad: ({ context }) => {
    requirePermission(context.me, ['notifications.write', 'settings.read'], 'any');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...notificationTemplatesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: NotificationTemplatesPage,
});
